var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "warpp" },
    [
      _c(
        "el-popover",
        {
          attrs: { placement: "bottom-start", trigger: "hover" },
          scopedSlots: _vm._u([
            {
              key: "reference",
              fn: function () {
                return [
                  _c("el-button", { attrs: { size: "small", plain: "" } }, [
                    _vm._v(_vm._s(_vm.$t("basicData.ImportDownload"))),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c(
            "div",
            { staticClass: "feet" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.onDownloadTemplate },
                },
                [_vm._v(_vm._s(_vm.$t("basicData.DownloadTheTemplate")))]
              ),
              _c("upload-excel", {
                staticClass: "feet-btn",
                attrs: {
                  "on-success": _vm.importLogistics,
                  "but-name": _vm.$t("basicData.BulkImport"),
                },
              }),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.downloadOffer },
                },
                [_vm._v(_vm._s(_vm.$t("basicData.DownloadTheQuote")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }